var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2A3069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3202 5.9247C10.3202 3.9447 9.36 2.26508 8.64 1.72508C8.64 1.72508 8.57981 1.66489 8.57981 1.7847C8.52019 5.5647 6.59981 6.58508 5.58 8.02508C3.12019 11.2049 5.4 14.7447 7.74 15.4051C9.06019 15.7651 7.44019 14.7447 7.26019 12.6449C6.95981 10.0051 10.3202 8.0847 10.3202 5.9247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5802 7.24487C11.4598 7.72469 10.98 8.74506 10.3202 9.70469C8.1 12.8851 9.36 14.4449 10.08 15.2847C10.5002 15.7651 10.08 15.2847 11.0998 14.8049C11.16 14.7447 13.14 13.7249 13.32 11.3849C13.5602 9.10506 12.1202 7.66506 11.5802 7.24487Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHt);
export default __webpack_public_path__ + "static/media/ht.ce31645abab4a5b6a82d10e3b99bc89f.svg";
export { ForwardRef as ReactComponent };